import React, { useState, useContext, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Switch,
  Modal,
  Space,
  Checkbox,
} from "antd";
import signinLogo from "../../assets/images/logo.svg";
import SuccessfullyIcon from "../../assets/images/success-icon-green.svg";

import Container from "react-bootstrap/Container";
import Footer from "../../components/layout/Footer";
const { Title } = Typography;
const { Content } = Layout;

const SuccessfullyIndex = () => {
  const navigate = useNavigate();


const handleChange = () =>{
  navigate("/sign-in")
}

  return (
    <>
      <Layout className="layout-default layout-signin">
        <Container>
          <Content className="signin">
            <div className="signup-logo-header">
              <img src={signinLogo} alt="" />
            </div>
            <div className="successfully-outer">
              <img src={SuccessfullyIcon} />
              <h6>Successfully Verified</h6>
              <p>
                Welcome to Wehad Bot ! Your account is now set up and ready to
                use.
              </p>
              <Button
                className="fill-btn"
                type="primary"
                htmlType="submit"
                onClick={handleChange}
              >
                Continue
              </Button>
            </div>
          </Content>
        </Container>
        <Footer />
      </Layout>
    </>
  );
};

export default SuccessfullyIndex;
